import React from 'react';
import PeoplesWidget from '../../../shared/components/PeoplesWidget';

const Peoples = (props) => {
  return (
    <PeoplesWidget
      label="туристы"
      adults={props.adults}
      kids={props.kids}
      ages={props.ages}
      buttonReset={true}
      onChoose={props.onChoose}
      cssClass="peopleAmount"
      width={220}
    />
  );
};

export default Peoples;
